import { ReactNode } from 'react';

interface ColumnProps {
  children: ReactNode;
  className?: string;
}

export const Column = ({ children, className = '' }: ColumnProps): JSX.Element => (
  <div className={`flex flex-col w-full items-center ${className}`}>
    {children}
  </div>
);
